import { GET_APPLICATIONS_BY_COMPANY_ID_LIST, GET_DASHBOARD_APPLICATIONS_BY_COMPANY_ID_LIST_PAGINATION, GET_TOTAL_AUTHORIZED_CREDIT } from "../constants";


const initialState = {
    dashboardApplicationList: [],
    dashboardApplicationListPaginationData: {
        data: [],
        totalCount: 0,
        pageSize: 5
    },
    totalAuthorizedCredit: 0,
    RemainingAuthorizedCredit: 0
};

export default function (state = initialState, action) {
    let dashboardApplicationList = [],
        dashboardApplicationListPaginationData = {},
        totalAuthorizedCredit = 0;
    switch (action.type) {
        case GET_APPLICATIONS_BY_COMPANY_ID_LIST:
            dashboardApplicationList = action.payload ? action.payload : state.dashboardApplicationList;

            return Object.assign({}, state, {
                dashboardApplicationList: dashboardApplicationList,
            });
        case GET_DASHBOARD_APPLICATIONS_BY_COMPANY_ID_LIST_PAGINATION:
            if (action.payload) {
                dashboardApplicationListPaginationData = {
                    data: action.payload.data,
                    totalCount: action.payload.totalCount,
                    pageSize: 5
                }
            }
            return Object.assign({}, state, {
                dashboardApplicationListPaginationData: dashboardApplicationListPaginationData
            });
        case GET_TOTAL_AUTHORIZED_CREDIT:
            totalAuthorizedCredit = action.payload.filter(item => item.creditInformation)
                .map(item => item.creditInformation.authorizedCredit)
                .reduce((prevCredit, currCredit) => prevCredit + currCredit, 0);
            return Object.assign({}, state, {
                totalAuthorizedCredit: totalAuthorizedCredit
            });
        default:
            return state;
    }
}